import styled from "styled-components";
import { Typography, IconButton, Button } from "@material-ui/core";
import { Apps, Help, HelpOutlined, MoreVert } from "@material-ui/icons";
import { useState } from 'react';
import {
    makeStyles,
} from '@material-ui/core/styles';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';


const TopUpStyles = makeStyles((theme) => ({
    versionHeader: {
        fontWeight: 600,
        color: "#3f7e32",
        fontSize: "25px",
        fontFamily: "Hind, sans-serif",
        marginBottom: "0px"
    },
    titleHeader: {
        fontWeight: 320,
        color: "#3f7e32",
        fontSize: "17px",
        fontFamily: "Hind, sans-serif",
    },
    title: {
        fontSize: '12px',
    }
}));

export default function NavMenu() {

    const classes = TopUpStyles();

    return (
        <Container style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
                <Grid item xs={2}>
                    
                </Grid>
                <Grid item xs={8}>
                    <p style={{ color: "#a1a1a1", fontSize: "13px" }}>Pusat Pengelolaan dan Penyebarluasan Informasi Geospasial</p>
                </Grid>
                <Grid item xs={2} >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Button component="a" onClick={() => window.open("https://www.big.go.id/")}>Tentang BIG</Button>
                        <Button component="a" onClick={() => window.open("https://www.big.go.id/")}>Kontak</Button>
                    </div>
                </Grid>
            </Grid>
            <p style={{ color: "#949494", fontSize: "13px" }}> © 2021 @ Badan Informasi Geospasial</p>
        </Container>
    )
}
/*
const Container = styled.div`
  display: flex;
  padding: 5px 15px;
  height: 7.7vh;
  background-color: white;
  border-bottom: 2px solid #3f7e32;
`;
*/
const ImageList = styled.div`
  margin-left: 10px;
  font-size: 12px;
  display: flex;
  width: 60%;
  justify-content: space-around;
`;
const LeftTopMenu = styled.div`
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const Logo = styled.div`
  padding-left: 5px;
`;


const RighTopMenu = styled.div`
  display:flex;
  flex-grow:1;
  justify-content: flex-end;
`;

const AppContainer = styled.div`
    padding: 0px 10px 10px 10px;
    width: 300px;
`;

const ListApp = styled.ul`
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    padding: 0px;
    justify-content: space-around;
`;

const ItemApp = styled.li`
    width: 80px;
    height: 80px;
    border-radius: 5px;
    border: 1px solid #eee;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 5px;
    cursor: pointer;
    &:hover{
        background-color: #eff;
        box-shadow: 4px 4px 8px 0 rgba(0, 0, 255, 0.2)
    }
`;

const HelpContainer = styled.div`
    width: 200px;
`;
